import { render, staticRenderFns } from "./order2.vue?vue&type=template&id=0fccef08&"
import script from "./order2.vue?vue&type=script&lang=js&"
export * from "./order2.vue?vue&type=script&lang=js&"
import style0 from "./order2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports